import { createAction } from "redux-actions";

import { CATEGORIES_LOADED, CATEGORIES_ERROR } from "../constants/actionTypes";
import * as Categories from "../api/categories";
import {
  getExcludedCategoryIds,
  filterExcludedCategories,
} from "../helpers/categoryFilter";

const getCategorySuccess = createAction(CATEGORIES_LOADED);
const getCategoryFailure = createAction(CATEGORIES_ERROR);

export function getCategory() {
  return (dispatch) =>
    Categories.getCategory()
      .then((data) => {
        const rawCategories = data.data || [];
        const excludedIdsSet = getExcludedCategoryIds(rawCategories);
        const excludedIds = Array.from(excludedIdsSet);
        const filteredData = filterExcludedCategories(
          rawCategories,
          excludedIdsSet,
        );

        dispatch(
          getCategorySuccess({
            filteredData,
            excludedIds,
          }),
        );
      })
      .catch((error) => {
        dispatch(getCategoryFailure(error));
      });
}
